import { getPatgames as getPatgamesApi } from '../api/patgames'

export async function getPatgames(esta_id) {
  return getPatgamesApi(esta_id);
}